'use strict';

module.exports = {
    setTabNextFocus: function (focusParams) {
        const TAB_KEY_CODE = 9;
        const e = focusParams.event;
        if (!(e.key === 'Tab' || e.keyCode === TAB_KEY_CODE)) return;

        const $container = $(focusParams.containerSelector);

        // LEGACY fallback approach
        if (focusParams.firstElementSelector && focusParams.lastElementSelector) {
            let $first = $container.find(focusParams.firstElementSelector);
            let $last = $container.find(focusParams.lastElementSelector);

            if ($last.is(':disabled') && focusParams.nextToLastElementSelector) {
                $last = $container.find(focusParams.nextToLastElementSelector);
            }

            if (e.shiftKey) {
                if ($(document.activeElement).is($first)) {
                    e.preventDefault();
                    $last.focus();
                }
            } else if ($(document.activeElement).is($last)) {
                e.preventDefault();
                $first.focus();
            }

            return;
        }

        // MODERN fallback: auto-detect all focusable elements
        const $focusableEls = $container
        .find('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable]')
        .filter(':visible');

        if (!$focusableEls.length) return;

        const firstEl = $focusableEls[0];
        const lastEl = $focusableEls[$focusableEls.length - 1];

        if (e.shiftKey) {
            if (document.activeElement === firstEl) {
                e.preventDefault();
                lastEl.focus();
            }
        }
        if (!e.shiftKey) {
            if (document.activeElement === lastEl) {
                e.preventDefault();
                firstEl.focus();
            }
        }
    },
    isFocusable: function ($el) {
        if (!$el || !$el.length) return false;
        if (!$el.is(':visible')) return false;
        if ($el.is(':disabled,[disabled]')) return false;
        if ($el.closest('[aria-hidden="true"]').length) return false;
        if ($el.closest('[inert]').length) return false;

        var isNativeFocusable = $el.is('a[href],button,input,select,textarea,[contenteditable="true"]');
        var hasTabindex = $el.is('[tabindex]');
        if (!isNativeFocusable && !hasTabindex) return false;

        return true;
    },
    /**
     * Attempts to focus $el, making up to maxAttempts tries every intervalMs.
     * If within the allotted time the element never becomes focusable — do nothing.
     * @param {jQuery|Function} $el jQuery element or function returning a jQuery element
     * @param {Object} opts { intervalMs: 100, maxAttempts: 20, ensureTabindex: true }
     */
    focusWithPolling: function ($el, opts) {
        // eslint-disable-next-line no-param-reassign
        opts = opts || {};
        var intervalMs = typeof opts.intervalMs === 'number' ? opts.intervalMs : 100;
        var maxAttempts = typeof opts.maxAttempts === 'number' ? opts.maxAttempts : 20;
        var ensureTabidx = opts.ensureTabindex !== false; // defaults to true
        var self = this;
        var attempts = 0;
        var timer = setInterval(function () {
            attempts++;

            if (typeof $el === 'function') {
                // eslint-disable-next-line no-param-reassign
                $el = $el(); // expected to return a jQuery object
            }

            if (self.isFocusable($el)) {
                clearInterval(timer);
                if (ensureTabidx && !$el.is('[tabindex]') && !$el.is('a,button,input,select,textarea,[contenteditable="true"]')) {
                    $el.attr('tabindex', '-1');
                }
                $el.focus();
            } else if (attempts >= maxAttempts) {
                clearInterval(timer);
            }
        }, intervalMs);
    },
    announceQuantityChange: function (text) {
        var BASE_ID = 'sr-qty-status';
        var $scope;
        var regionId;

        $scope = $(document.activeElement).closest('[aria-modal="true"], .modal');
        if ($scope.length) {
            regionId = $scope.attr('id') ? $scope.attr('id') + '-' + BASE_ID : 'modal-' + BASE_ID;
        } else {
            $scope = $(document.activeElement).closest('.minicart-flyout');
            if ($scope.length) {
                regionId = 'minicart-' + BASE_ID;
            } else {
                $scope = $(document.body);
                regionId = BASE_ID;
            }
        }

        var $el = $scope.find('#' + regionId);

        if (!$el.length) {
            $el = $('<div>', {
                id: regionId,
                role: 'status',
                'aria-live': 'polite',
                'aria-atomic': 'true',
                class: 'sr-only'
            }).appendTo($scope);
        }

        setTimeout(function () {
            $el.text(text);
        }, 100);
    },
    announceCartItemsCount: function (itemsText, delay) {
        var BASE_ID = 'sr-items-count-status';
        var $scope;
        var regionId;

        // Detect scope (modal, minicart, or main page) similar to announceQuantityChange
        // IMPORTANT: Capture scope immediately, before any focus changes occur
        $scope = $(document.activeElement).closest('[aria-modal="true"], .modal');
        if ($scope.length) {
            regionId = $scope.attr('id') ? $scope.attr('id') + '-' + BASE_ID : 'modal-' + BASE_ID;
        } else {
            $scope = $(document.activeElement).closest('.minicart-flyout');
            if ($scope.length) {
                regionId = 'minicart-' + BASE_ID;
            } else {
                $scope = $(document.body);
                regionId = BASE_ID;
            }
        }

        var $el = $scope.find('#' + regionId);

        if (!$el.length) {
            $el = $('<div>', {
                id: regionId,
                role: 'status',
                'aria-live': 'assertive',
                'aria-atomic': 'true',
                class: 'sr-only'
            }).appendTo($scope);
        }

        // Use custom delay if provided, otherwise default to 300ms
        var announceDelay = typeof delay === 'number' ? delay : 300;

        // Clear text first to force NVDA to detect a change, then set new text
        $el.text('');

        setTimeout(function () {
            $el.text(itemsText);
        }, announceDelay);
    },
    handleShippingMethodArrows: function () {
        var selector = 'input[type="radio"][name$="_shippingAddress_shippingMethodID"]';
        $(document).on('keydown', selector, function (e) {
            if (!/Arrow(Up|Down|Left|Right)/.test(e.key)) {
                return;
            }

            e.preventDefault();
            var $radios = $(selector);
            var idx = $radios.index(this);
            var dir = (e.key === 'ArrowUp' || e.key === 'ArrowLeft') ? -1 : 1;
            var next = (idx + dir + $radios.length) % $radios.length;

            var $target = $radios.eq(next);
            var $list = $target.closest('.shipping-method-list');
            $radios.prop('checked', false);
            setTimeout(function () {
                $target.prop('checked', true).trigger('change');
            }, 0);
            var $loader = $('#shipping-method-loading');
            if (!$loader.length) {
                $loader = $('<div id="shipping-method-loading" class="sr-only" tabindex="-1" role="status">Loading.</div>');
                $list.before($loader);
            }
            $loader.focus();
        });
    },
    /**
     * Temporarily hides a trigger button from screen readers
     * by applying aria-hidden and an empty aria-label.
     * Original attributes are cached on the element via data().
     *
     * @param {jQuery} $btn The trigger button element
     */
    muteTrigger: function ($btn) {
        if (!$btn || !$btn.length) return;

        // Save original attributes if not already saved
        if (!$btn.data('a11y-orig')) {
            $btn.data('a11y-orig', {
                ariaLabel: $btn.attr('aria-label')
            });
        }

        $btn.attr('aria-label', '-');
    },
    /**
     * Restores the trigger button's original aria attributes
     * after muteTrigger() was called.
     *
     * @param {jQuery} $btn The trigger button element
     */
    unmuteTrigger: function ($btn) {
        if (!$btn || !$btn.length) return;

        var orig = $btn.data('a11y-orig');
        if (orig) {
            if (orig.ariaLabel !== undefined) {
                $btn.attr('aria-label', orig.ariaLabel);
            } else {
                setTimeout(function () {
                    $btn.removeAttr('aria-label');
                }, 1000);
            }
            $btn.removeData('a11y-orig');
        } else {
            // fallback: clean slate
            setTimeout(function () {
                $btn.removeAttr('aria-label');
            }, 1000);
        }
    }
};
